export default "__VITE_ASSET__Cq8Ebx0P__"